let info = {
  name: "Usama Khurshid",
  logo_name: "Usama Khurshid",
  flat_picture: require("./src/assets/profile.png"),
  config: {
    use_cookies: true,
    navbar: {
      blur: false,
    },
  },
  description:
    "Full Stack Developer at Mern IT Solutions, building scalable and secure web applications with modern JavaScript technologies such as Next.js, React, Angular, Node.js, MongoDB and MySQL. I enjoy working end-to-end on products, from clean, responsive UIs to robust APIs and cloud deployments (Docker, AWS, Swagger-driven APIs). With a BS in Software Engineering and over 5 years of experience, I'm always learning new tools and patterns to ship high-quality, user-focused solutions.",
  links: {
    linkedin: "https://www.linkedin.com/in/usama-khurshid-6a74a7196/",
    github: "https://github.com/UsamaKhurshid3240",
    twitter: "https://twitter.com/usama00822224",
    stackOverflow: "https://stackoverflow.com/users/17991308/usama-khurshid",
    mail: "usamakhurshid665@gmail.com",
    website: "https://usamakhurshid.netlify.app/",
    resume:
      "https://docs.google.com/document/d/18Fm53yPLlY5GWjUVW9zUqHv3YTNkZSfTmcx5HRZCEkc/",
  },
  education: [
    {
      id: 1,
      name: "International Islamic University",
      place: "Islamabad, Pakistan",
      degree: "Bachelor of Software Engineering (BSSE)",
      gpa: "3.3 CGPA",
      date: "2016 – 2020",
      description:
        "Bachelor of Software Engineering with focus on full-stack development and software architecture.",
    },
    {
      id: 2,
      name: "Gordon College Rawalpindi",
      place: "Rawalpindi, Pakistan",
      degree: "Faculty of Science – F.Sc",
      date: "2013 – 2015",
      description: "Higher secondary education in science.",
    },
  ],
  experience: [
    {
      id: 1,
      name: "F10 Software Solutions / Mern IT Solutions",
      place: "Islamabad, Pakistan",
      position: "Full Stack Developer & Team Lead",
      date: "Nov 2020 – Present",
      description:
        "Lead full-stack development for OCCY and Smart Recruit Online, building scalable and secure SaaS platforms. Work across React.js, Next.js, Angular, Node.js, MySQL, MongoDB, Docker Swarm, Swagger API and AWS to deliver high-quality features end-to-end. Own front-end architecture, performance, and code quality while collaborating closely with product, design, and back-end teams.",
      skills: [
        "React.js",
        "Next.js",
        "Angular",
        "Node.js",
        "MySQL",
        "MongoDB",
        "AWS",
        "Docker",
        "Swagger",
        "Git",
        "Redux",
        "TypeScript",
      ],
    },
    {
      id: 2,
      name: "Freelancing",
      place: "Pakistan",
      position: "Web Developer (Freelance)",
      date: "Jan 2020 – Present",
      description:
        "Self-employed web developer building custom web applications, dashboards, and front-end experiences for clients. Deliver responsive UIs, API integrations, and maintainable codebases using React, Angular, Node.js and modern JavaScript tooling.",
      skills: ["React.js", "Angular", "Node.js", "JavaScript", "Web applications"],
    },
    {
      id: 3,
      name: "SyntecX Solutions",
      place: "Islamabad, Pakistan",
      position: "Front End Developer – Internship",
      date: "Jun 2019 – Aug 2019",
      description:
        "Engaged in a dynamic internship focusing on Telenor projects. Gained hands-on experience with AngularJS, Angular 2, React.js, Node.js, and MongoDB. Contributed to diverse technical tasks in a project-driven environment.",
      skills: ["AngularJS", "Angular 2", "React.js", "Node.js", "MongoDB"],
    },
  ],
  skills: [
    {
      title: "Frontend",
      info: [
        "JavaScript / ES6–ES13",
        "React.js",
        "Context API / Redux",
        "AngularJS / Angular 2+",
        "Next.js",
        "Ionic",
        "Bootstrap 5",
        "Material UI",
        "Semantic UI",
      ],
      icon: "fas fa-laptop-code",
    },
    {
      title: "Backend & Data",
      info: ["Node.js / Express.js", "MySQL", "MongoDB", "Firebase", "ClickHouse", "Superset"],
      icon: "fa fa-database",
    },
    {
      title: "Tools & DevOps",
      info: [
        "Git / GitHub",
        "Postman",
        "Heroku",
        "AWS (S3, Fargate, ECS)",
        "Docker / Docker Swarm",
        "Swagger",
        "Jest",
        "Jira",
        "Ubuntu / Linux",
      ],
      icon: "fas fa-tools",
    },
    {
      title: "Design & Other",
      info: ["Adobe Ps, Ai, Xd", "Rasa Framework", "Python", "Java"],
      icon: "fa fa-pencil-square-o",
    },
  ],
  portfolio: [
    // Professional / CV projects
    {
      name: "OCCY",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=OCCY" }],
      technologies: ["React.js", "Node.js", "MySQL", "Recruitment"],
      category: "Recruitment platform",
      visit: "https://app.occy.com",
      github: "",
      description:
        "Led front-end team in developing OCCY, an end-to-end recruitment platform for high-volume hourly hiring. Built front-end and backend components with React.js, Node.js, and MySQL. Integrated CV-Library for candidate search and profile purchases.",
    },
    {
      name: "Smart Recruit Online",
      pictures: [
        {
          img: "https://placehold.co/600x360/f1f5f9/64748b?text=Smart+Recruit",
        },
      ],
      technologies: ["React.js", "Angular", "Node.js", "MySQL"],
      category: "Recruitment SaaS",
      visit: "https://app.smartrecruitonline.com",
      github: "",
      description:
        "Comprehensive recruitment platform. Collaborated on intuitive front-end features with React.js and Angular, Node.js for back-end, API integrations, and ensured performance, scalability, and security.",
    },
    {
      name: "Smart Recruit Online – Candidate Portal",
      pictures: [
        {
          img: "https://placehold.co/600x360/f1f5f9/64748b?text=Candidate+Portal",
        },
      ],
      technologies: ["Angular 9", "Node.js"],
      category: "Candidate portal",
      visit: "https://portal.smartrecruitonline.com",
      github: "",
      description:
        "Led development of candidate portal for Smart Recruit Online with Angular 9. Implemented secure authentication, real-time updates, and data synchronization with back-end developers.",
    },
    {
      name: "Pali Apps",
      pictures: [
        { img: "https://placehold.co/600x360/f1f5f9/64748b?text=Pali+Apps" },
      ],
      technologies: ["Angular", "React.js", "Encryption"],
      category: "Secure email platform",
      visit: "https://paliapps.com",
      github: "",
      description:
        "Platform for secure email communication with encryption and decryption. Collaborated on user-friendly interface, security measures, and testing for reliability and privacy.",
    },
    {
      name: "Think Compared",
      pictures: [
        {
          img: "https://placehold.co/600x360/f1f5f9/64748b?text=Think+Compared",
        },
      ],
      technologies: ["React.js", "Node.js", "MySQL", "MERN"],
      category: "Product search",
      visit: "https://thinkcompared.com",
      github: "",
      description:
        "Spearheaded use of React.js, Node.js, and MySQL to architect an independent product search service with intuitive UI, real-time updates, and streamlined project management.",
    },
    {
      name: "Baymax – Stress Manager",
      pictures: [
        {
          img: "https://placehold.co/600x360/f1f5f9/64748b?text=Baymax",
        },
      ],
      technologies: ["React.js", "Node.js", "MongoDB", "Rasa", "ML"],
      category: "Final year project",
      visit: "https://github.com/UsamaKhurshid3240/Baymax",
      github: "https://github.com/UsamaKhurshid3240/Baymax",
      description:
        "Interactive stress manager web app with a chatbot assistant to monitor, identify, and resolve stress. Machine learning, facial recognition, Rasa Framework, React.js, Node.js, MongoDB.",
    },
    // GitHub repositories
    {
      name: "CareerWebBuilder",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=CareerWebBuilder" }],
      technologies: ["TypeScript"],
      category: "Web app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/CareerWebBuilder",
      description: "Web customization tool built with TypeScript.",
    },
    {
      name: "VS-Extension",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=VS+Extension" }],
      technologies: ["TypeScript", "VS Code"],
      category: "VS Code extension",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/VS-Extension",
      description: "Visual Studio Code extension project.",
    },
    {
      name: "Agentic-Poc",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Agentic+Poc" }],
      technologies: ["JavaScript"],
      category: "Web app",
      visit: "https://agentic-poc-five.vercel.app",
      github: "https://github.com/UsamaKhurshid3240/Agentic-Poc",
      description: "Agentic proof-of-concept application. Live demo on Vercel.",
    },
    {
      name: "Test Case Generator",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Test+Case+Generator" }],
      technologies: ["JavaScript"],
      category: "Dev tools",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/test-case-generator",
      description: "Automated test cases generator for development workflows.",
    },
    {
      name: "Coming-Soon",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Coming+Soon" }],
      technologies: ["CSS"],
      category: "Web template",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Coming-Soon",
      description: "Zaaviya Coming Soon web template.",
    },
    {
      name: "My-App",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=My+App" }],
      technologies: ["React.js", "SCSS"],
      category: "Web app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/My-App",
      description: "ReactJS project with modern styling.",
    },
    {
      name: "Facial Recognition",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Facial+Recognition" }],
      technologies: ["Jupyter Notebook", "Python", "ML"],
      category: "ML / Research",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Facial-Recognizition",
      description: "Facial recognition project using machine learning.",
    },
    {
      name: "JOTTING",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=JOTTING" }],
      technologies: ["Notes"],
      category: "App",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/JOTTING",
      description: "Your notes – a notes application.",
    },
    {
      name: "Resume",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Resume" }],
      technologies: ["Resume"],
      category: "Personal",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Resume",
      description: "Resume repository.",
    },
    {
      name: "WikiExam",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=WikiExam" }],
      technologies: ["TypeScript"],
      category: "Web app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/WikiExam",
      description: "Online Exam System App (WikiExam).",
    },
    {
      name: "Coursera AngularJS",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=AngularJS" }],
      technologies: ["AngularJS"],
      category: "Learning",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Coursera-Angularjs",
      description: "AngularJS course certificate from Coursera.",
    },
    {
      name: "ReactJs Login & Register",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=React+Auth" }],
      technologies: ["React.js", "JavaScript"],
      category: "Web app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/ReactJs",
      description: "Login & Register implementation with React.",
    },
    {
      name: "Mario Game",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Mario+Game" }],
      technologies: ["Construct 2", "Game"],
      category: "Game",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Mario-Game",
      description: "Mario-style game using Construct 2.",
    },
    {
      name: "Ionic Node.js API Call",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Ionic+API" }],
      technologies: ["Ionic", "Node.js", "MongoDB", "TypeScript"],
      category: "Mobile / Full stack",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Ionic-Nodejs-Api-Call",
      description: "Simple Ionic app using Node.js API and MongoDB.",
    },
    {
      name: "Java Android Tic Tac Toe",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Android+Game" }],
      technologies: ["Java", "Android"],
      category: "Mobile app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Java-Android-Game-App-",
      description: "Simple Java Android Tic Tac Toe game.",
    },
    {
      name: "Kotlin Android Calculator",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Kotlin+Calculator" }],
      technologies: ["Kotlin", "Android"],
      category: "Mobile app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Kotlin-Android-App",
      description: "Simple Android calculator using Kotlin.",
    },
    {
      name: "Book List",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Book+List" }],
      technologies: ["TypeScript"],
      category: "Web app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/book_List",
      description: "Book list application.",
    },
    {
      name: "Employee Management System",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=EMS" }],
      technologies: ["Node.js", "MongoDB", "Handlebars", "HTML"],
      category: "Full stack",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Employee-Management-System",
      description: "CRUD operations using Node.js, MongoDB, and Handlebars.",
    },
    {
      name: "Ionic Book Store",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Ionic+Book+Store" }],
      technologies: ["Ionic", "TypeScript"],
      category: "Mobile app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Ionic_Book_Store",
      description: "Ionic app that displays books list and book detail with add/delete functionality.",
    },
    {
      name: "Netlify Angular Example",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Angular+Netlify" }],
      technologies: ["Angular", "HTML"],
      category: "Web app",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/netlifyangularexample",
      description: "Angular application deployed to Netlify.",
    },
    {
      name: "Mobile Application Development",
      pictures: [{ img: "https://placehold.co/600x360/f1f5f9/64748b?text=Mobile+App" }],
      technologies: ["TypeScript"],
      category: "Mobile",
      visit: "",
      github: "https://github.com/UsamaKhurshid3240/Mobile-Application-Developement",
      description: "Mobile application development project.",
    },
  ],
  portfolio_design: [],
  recommendations: [
    {
      title:
        "Usama is a highly skilled full-stack developer with a knack for seamlessly integrating front-end and back-end technologies to deliver robust and user-friendly web applications. His attention to detail and innovative problem-solving ensure every project is executed to a high standard. He has a strong foundation in React on the front end and Node.js on the back end, and consistently keeps up with modern industry practices.",
      author: "Shehzad Ahmed",
      position: "Backend Developer",
      company: "Mern IT Solutions",
      location: "Pakistan",
    },
    {
      title:
        "I had the pleasure of working alongside Usama and was consistently impressed by his commitment to excellence. He is a proactive full stack developer who takes the lead on new challenges and navigates complex technical problems with ease. Usama is a strong team player, delivers high-quality solutions, and goes above and beyond to ensure project success.",
      author: "Sajjad Ahmed",
      position: "Full Stack Developer",
      company: "F10 Software Solutions",
      location: "Pakistan",
    },
  ],
};

export default info;
